import React from 'react'
import styled from 'styled-components'
import Loader from '@bufferapp/ui/Loader'

const LoaderWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export function WrappedLoader() {
  return (
    <LoaderWrapper>
      <Loader />
    </LoaderWrapper>
  )
}
